<template>

<div class="button" :class="{[classTheme]: true, [classSize]: true, 'is-expand': expand, 'is-fixed': fixed, 'has-icon': icon, 'has-arrow': arrow, 'is-loading': loading, 'is-disabled': disabled}">

	<router-link :to="link" v-if="to" class="button-wrapper">

		<app-icon :name="icon" v-if="icon" class="button-icon" />
		<div class="button-text">{{ text }}</div>
		<app-icon name="chevron-right" v-if="arrow" class="button-icon is-arrow" />

	</router-link>

	<a :href="href" :target="target" v-if="href" class="button-wrapper">

		<app-icon :name="icon" v-if="icon" class="button-icon" />
		<div class="button-text">{{ text }}</div>
		<app-icon name="chevron-right" v-if="arrow" class="button-icon is-arrow" />

	</a>

	<div class="button-wrapper" v-if="!to && !href" v-on:click="$emit('click')">

		<app-icon :name="icon" v-if="icon" class="button-icon" />
		<app-icon name="success" v-if="success" class="button-icon" />
		<div class="button-text">{{ text }}</div>
		<app-icon name="chevron-right" v-if="arrow" class="button-icon is-arrow" />

	</div>

    <app-icon name="caret-down" class="button-caret" v-if="caret" />

</div>

</template>

<script>

export default {

	props: ['icon', 'href', 'target', 'size', 'caret', 'success', 'fail', 'expand', 'fixed', 'text', 'theme', 'to', 'loading', 'arrow', 'disabled', 'query'],

	computed: {

        link: function() {

            return (typeof(this.to) === 'string') ? {name: this.to, query: this.query} : this.to

        },

		classTheme: function() {

			var theme = this.theme || 'blue'

			if (this.success) theme = 'green'
			if (this.fail) theme = 'red'

			return 'theme-' + theme

		},

		classSize: function() {

			return 'size-' + ((this.size) ? this.size : 'normal')

		}

	}

}

</script>

<style scoped>

.button {
	display: inline-block;
	height: 40px;
	line-height: 40px;
	text-transform: uppercase;
	transition: all 100ms linear;
	cursor: pointer;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	border-radius: 4px;
	white-space: nowrap;
	user-select: none;
}

.button.is-expand {
    width: 100%;
}

.button.is-fixed {
    min-width: 120px;
}

.is-mobile .button.is-fixed {
    min-width: auto;
}

.button.size-small {
    height: 24px;
    line-height: 24px;
}

.button.is-disabled {
	opacity: 0.5;
	pointer-events: none;
}

.button.is-loading {
	pointer-events: none;
	background-image: url('data:image/gif;base64,R0lGODlhEAALAPQAAP////////7+/v7+/v7+/v7+/v////7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/gAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCwAAACwAAAAAEAALAAAFLSAgjmRpnqSgCuLKAq5AEIM4zDVw03ve27ifDgfkEYe04kDIDC5zrtYKRa2WQgAh+QQJCwAAACwAAAAAEAALAAAFJGBhGAVgnqhpHIeRvsDawqns0qeN5+y967tYLyicBYE7EYkYAgAh+QQJCwAAACwAAAAAEAALAAAFNiAgjothLOOIJAkiGgxjpGKiKMkbz7SN6zIawJcDwIK9W/HISxGBzdHTuBNOmcJVCyoUlk7CEAAh+QQJCwAAACwAAAAAEAALAAAFNSAgjqQIRRFUAo3jNGIkSdHqPI8Tz3V55zuaDacDyIQ+YrBH+hWPzJFzOQQaeavWi7oqnVIhACH5BAkLAAAALAAAAAAQAAsAAAUyICCOZGme1rJY5kRRk7hI0mJSVUXJtF3iOl7tltsBZsNfUegjAY3I5sgFY55KqdX1GgIAIfkECQsAAAAsAAAAABAACwAABTcgII5kaZ4kcV2EqLJipmnZhWGXaOOitm2aXQ4g7P2Ct2ER4AMul00kj5g0Al8tADY2y6C+4FIIACH5BAkLAAAALAAAAAAQAAsAAAUvICCOZGme5ERRk6iy7qpyHCVStA3gNa/7txxwlwv2isSacYUc+l4tADQGQ1mvpBAAIfkECQsAAAAsAAAAABAACwAABS8gII5kaZ7kRFGTqLLuqnIcJVK0DeA1r/u3HHCXC/aKxJpxhRz6Xi0ANAZDWa+kEAA7AAAAAAAAAAAA');
}

.button.theme-green {
	background-color: var(--color-green);
	color: #fff;
}

.is-desktop .button.theme-green:not(.is-loading):hover {
	background-color: var(--color-green-dark);
}

.button.theme-red {
	background-color: var(--color-red);
	color: #fff;
}

.is-desktop .button.theme-red:not(.is-loading):hover {
	background-color: var(--color-red-dark);
}

.button.theme-yellow {
	background-color: var(--color-yellow);
	color: #fff;
}

.is-desktop .button.theme-yellow:not(.is-loading):hover {
	background-color: var(--color-yellow-dark);
}

.button.theme-white {
	background-color: #fff;
	color: var(--color-grey-dark);
}

.is-desktop .button.theme-white:not(.is-loading):hover {
	color: var(--color-grey);
}

.button.theme-grey {
	background-color: var(--color-grey-light);
	color: var(--color-grey-dark);
}

.is-desktop .button.theme-grey:not(.is-loading):hover {
	background-color: var(--color-grey-highlight);
}

.button.theme-blue {
	background-color: var(--color-blue-light);
	color: #fff;
}

.is-desktop .button.theme-blue:not(.is-loading):hover {
	background-color: var(--color-blue-dark);
}

.button.theme-facebook {
	background-color: #3C5A99;
	color: #fff;
}

.is-desktop .button.theme-facebook.is-loading,
.is-desktop .button.theme-facebook:hover {
	background-color: #203561;
}

.button.theme-twitter {
	background-color: #1DA1F2;
	color: #fff;
}

.is-desktop .button.theme-twitter.is-loading,
.is-desktop .button.theme-twitter:hover {
	background-color: #1087d0;
}

.button.theme-plain {
	color: var(--color-grey-dark);
}

.is-desktop .button.theme-plain.is-loading,
.is-desktop .button.theme-plain:hover {
	text-decoration: underline;
}

.button-wrapper {
	display: block;
	width: 100%;
	height: 40px;
	display: flex;
	flex-direction: row;
}

.button.is-expand .button-wrapper,
.button.is-fixed .button-wrapper {
    justify-content: center;
}

.button.size-small .button-wrapper {
    height: 24px;
}

.button.is-loading .button-wrapper {
	visibility: hidden;
}

.button-icon {
	width: 40px;
	height: 40px;
	line-height: 40px;
	font-size: 24px;
	text-align: center;
}

.button-icon.is-arrow {
    font-size: 16px;
}

.button.size-small .button-icon {
    height: 24px;
    width: 24px;
    line-height: 24px;
    font-size: 12px;
}

.button-text {
	font-size: 14px;
	padding: 0px 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.button.size-small .button-text {
    padding: 0px 8px;
    font-size: 12px;
}

.button.has-icon .button-text {
	padding-left: 5px;
}

.button.has-arrow .button-text {
	padding-right: 0px;
}

.button.size-small.has-icon .button-text {
    padding-left: 0px;
}

.button-caret {
    position: absolute;
    right: 20px;
    top: 13px;
}

</style>